// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../types';
import media from '../../../../../helpers/media';

export default styled<any, Theme>('img')`
  margin-bottom: .5rem;
  max-height: 7.5rem;
  max-width: 100%;

  ${media.md(css`
    margin-bottom: 1rem;
    max-height: 12.5rem;
  `)};
`;
